export enum CategoryType {
  INVALID = "INVALID",
  COMMON = "COMMON",
  ESTIMATION_CHANGED = "ESTIMATION_CHANGED",
  NON_COMPLIANCE = "NON_COMPLIANCE",
}
